import { api, serviceAccountApi } from '@ardoq/api';
import { APIServiceAccount } from '@ardoq/api-types';
import { ArdoqError, isArdoqError } from '@ardoq/common-helpers';
import { defer, map, startWith, tap } from 'rxjs';

const logErrorIfNeeded = (response: APIServiceAccount[] | ArdoqError) => {
  if (!isArdoqError(response)) return;
  api.logErrorIfNeeded(response);
};

export const serviceAccounts$ = defer(() =>
  serviceAccountApi.fetchServiceAccounts()
).pipe(
  tap(logErrorIfNeeded),
  map(serviceAccounts => {
    if (isArdoqError(serviceAccounts)) {
      return { serviceAccounts: [], isLoading: false, error: serviceAccounts };
    }
    return { serviceAccounts, isLoading: false, error: null };
  }),
  startWith({ serviceAccounts: [], isLoading: true, error: null })
);
